import http from "../AppConfig";
import {Encrypt} from "@/plugins/cryptojs";

const groupName = window.location.hostname.slice(
    0,
    window.location.hostname.indexOf(".", 0)
);

const c = encodeURIComponent(Encrypt(groupName));
class JobInformationService {
  deleteJobDetailInRedis(hash, token) {
    return http.delete(`jobs?hash=${hash}&c=${c}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  }

  deleteDispatchJobDetailInRedis(hash, token) {
    return http.delete(`dispatch-jobs?hash=${hash}&c=${c}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  }

  deleteCompanyDetailInRedis(hash, token) {
    return http.delete(`companies?hash=${hash}&c=${c}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  }
}

export default new JobInformationService();
